__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-17-1776419104-stable-dev/";